import { render } from "./AccountContractModal.vue?vue&type=template&id=562760d0"
import script from "./AccountContractModal.vue?vue&type=script&lang=ts"
export * from "./AccountContractModal.vue?vue&type=script&lang=ts"
script.render = render

export default script